import { defaultStyles } from "./variants/appCard.default";
import { compactStyles } from "./variants/appCard.compact";
import { paymnentStyles } from "./variants/appCard.payment";

export const appCardVariants = {
  default: defaultStyles,
  compact: compactStyles,
  payment: paymnentStyles
} as const;

export type AppCardVariant = keyof typeof appCardVariants;
